import isObject from 'lodash/isObject';
import * as T from 'prop-types';
import {applyAutoFilter, ReduxList} from '../../../_libs/redux-observable-list';
import {buildParentChannelSyncNotifier} from '../../../auth/utils/redux-lists';
import {BASE_REDUX_LIST_OPTIONS} from '../../../config/redux-list/index';
import filterTemplate from '../../../core-components/selectors/filters/projects-filter.html';
import {FilterModalOptions} from '../../../core-utilities/filters/FilterModalOptions';
import {sortByProperty} from '../../../core-utilities/filters/filterUtils';
import {applyDefaultReduxListComponentOptions} from '../../../core-utilities/redux/ReduxListContainer';
import {SYNC_PATH} from '../../../core-utilities/rx-utils';
import {removeByStatus} from '../../../tasks/filters/TasksFilterService';
import {getNavAssetProjects} from '../reducers/state';
import {logger} from './logger';
import {NAV_ASSET_PROJECT_LIST_PREFIX} from './state';


export const defaultFilterOptions = {
  status: {
    cancelled: true,
    pending: true,
    in_progress: true,
    complete: true,
  },
};

export const filterModalOptions = new FilterModalOptions({
  filterTemplate,
  filterOptions: defaultFilterOptions,
});

const parentPath = 'projects';
const resourcePath = `asset-projects`; // may need this for sync to post functionality
const childPath = 'assets';

const matchesAutoFilter = applyAutoFilter(['name', 'identifier'], 1);

export const reduxList = new ReduxList({
  ...BASE_REDUX_LIST_OPTIONS,
  prefix: NAV_ASSET_PROJECT_LIST_PREFIX,
  getState: getNavAssetProjects,
  pageSize: 100,
  hasParentId: true,
  useDelete: false,
  useFiltering: true,
  useAutoFilter: true,
  useFilterOptions: true,
  useSortOptions: false,
  applySortOptions,
  defaultSortOptions: {},
  defaultFilterOptions,
  isVisible,
  syncNotifier: buildParentChannelSyncNotifier(parentPath, childPath),
  listPath: parentId => `${parentPath}/${parentId}/${childPath}`,
  listSyncPath: parentId => `${parentPath}/${parentId}/${childPath}/${SYNC_PATH}`,
  logger,

  // cacheOptions: {
  //   localForage: asyncStorage,
  //   key: targetOptions.cacheName,
  // },
});

export const componentOptions = applyDefaultReduxListComponentOptions(reduxList.options, {
  filterModalOptions,
});

function isVisible(item, filterData) {
  if (!isObject(item)) return false;
  if (!matchesAutoFilter(item, filterData.filter)) return false;
  if (removeByStatus(item, filterData.filterOptions)) return false;
}

export function applySortOptions(list) {
  return list.sort(sortByProperty('name', true, true));
}

// TODO: define all data passed in this list
export const assetProjectsModelShape = T.shape({
  name: T.string,
  shortName: T.string,
  identifier: T.string,
  project: T.object,
  asset: T.object,
});



// WEBPACK FOOTER //
// ./src/js/app/navigation/redux/assetProjects.js